export const common = {
	common: {
		viewProject: "プロジェクトを見る",
		viewOnAppStore: "App Storeで見る",
		viewOnGitHub: "GitHubで見る",
		viewCompany: "会社を見る",
	},

	nav: {
		home: "ホーム",
		about: "プロフィール",
		projects: "プロジェクト",
		outputs: "アウトプット",
		services: "サービス",
		contact: "お問い合わせ",
		privacyPolicy: "プライバシーポリシー",
		termsOfService: "利用規約",
		commercialLaw: "特定商取引法",
		disclaimer: "免責事項",
	},

	footer: {
		copyright: "© 2026 Kazumasa Shimomura. All Rights Reserved.",
	},

	notFound: {
		title: "404",
		description: "お探しのページが見つかりませんでした。",
		backToHome: "ホームに戻る",
	},
} as const;
